<template>
  <pre
    v-if="debugInterval"
    class="participant-debug-info"
    @click.stop="toggleParticipantDebugInfo"
    >{{ debugInfo }}</pre
  >
</template>

<script>
export default {
  name: 'ParticipantDebugInfo',
  props: {
    participant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debugInterval: null,
      debugInfo: {},
    };
  },
  methods: {
    toggleParticipantDebugInfo() {
      if (this.debugInterval) {
        clearInterval(this.debugInterval);
        return (this.debugInterval = null);
      }

      this.debugInterval = setInterval(() => {
        const part = this.participant;
        if (!part || !part.tracks) return;

        const tracks = Array.from(part.tracks.values());
        const track = tracks.find((track) => track.kind === 'video') || {};
        if (!track) return;

        this.debugInfo = {
          dimensions: track.track?.dimensions || {},
          publishPriority: track.publishPriority,
          trackName: track.trackName,
          trackSid: track.trackSid,
        };
      }, 1000);
    },
  },

  beforeDestroy() {
    if (this.debugInterval) {
      clearInterval(this.debugInterval);
    }
  },
};
</script>
